import PropTypes from 'prop-types'
import { formatearFecha } from '../../helpers/helper'
import LinkButton from '../../ui/LinkButton'
import styles from './Pedido.module.css'

export const PedidoBody = ({ fechaPedido, pedidoItem, esVentas, mediosPago }) => {
  const {
    idPublicacion,
    idVendedor,
    idPedidoItem,
    fechaDespachado,
    esItemCalificado,
    fechaRecibido,
    estadoNombre,
    descripcionEstado,
    idMedioPago
  } = pedidoItem
  const pathCalificarProducto = `/CalificarProducto/${idPublicacion}/${idVendedor}/${idPedidoItem}`

  const obtenerMedioPago = () => {
    if (!mediosPago || mediosPago.length === 0) {
      return ''
    }

    const medioPago = mediosPago.find((mp) => mp.idMedioPago === idMedioPago)
    return medioPago?.nombre || ''
  }

  return (
    <div className={styles.pedidoBody}>
      <div>
        <div className={styles.pedidoDescripcion}>
          <span>
            <i className="fa fa-calendar-o" aria-hidden="true" />
            <strong>Compra:</strong> {formatearFecha(fechaPedido, 'F')}
          </span>
          <span>
            <i className="fa fa-truck" aria-hidden="true" />
            <strong>Enviado:</strong> {formatearFecha(fechaDespachado, 'F')}
          </span>
          <span>
            <i className="fa fa-gift" aria-hidden="true" />
            <strong>Entregado:</strong> {formatearFecha(fechaRecibido, 'F')}
          </span>
          <span>
            <i className="fa fa-credit-card" aria-hidden="true"></i>
            <strong>Método de pago:</strong> {obtenerMedioPago()}
          </span>
        </div>
        <div className={styles.estado}>
          <strong>Estado: </strong>
          {`${estadoNombre} ${descripcionEstado ? `(${descripcionEstado})` : ''}`}
        </div>
      </div>
      <div className={styles.items}>
        {!esVentas && (
          <LinkButton
            to={pathCalificarProducto}
            className={`${styles.califButton} ${esItemCalificado === 1 ? styles.disabledButton : ''}`}
          >
            <i className="fa fa-star" aria-hidden="true" />
            Calificar Producto
          </LinkButton>
        )}
        <LinkButton
          to={{
            pathname: `/Pedidos/${idPedidoItem}`,
            state: { ...pedidoItem, fechaPedido, esVentas }
          }}
          className={styles.califButton}
        >
          <i className="fa fa-search" aria-hidden="true" />
          Ver Detalle
        </LinkButton>
      </div>
    </div>
  )
}

PedidoBody.propTypes = {
  fechaPedido: PropTypes.string.isRequired,
  pedidoItem: PropTypes.shape({
    idPublicacion: PropTypes.number,
    idVendedor: PropTypes.number,
    idPedidoItem: PropTypes.number,
    fechaDespachado: PropTypes.string,
    esItemCalificado: PropTypes.number,
    fechaRecibido: PropTypes.string,
    estadoNombre: PropTypes.string,
    descripcionEstado: PropTypes.string,
    idMedioPago: PropTypes.number
  }).isRequired,
  esVentas: PropTypes.bool.isRequired,
  mediosPago: PropTypes.arrayOf(
    PropTypes.shape({
      idMedioPago: PropTypes.number.isRequired,
      nombre: PropTypes.string.isRequired
    })
  )
}
